import { useState } from "react";
import axios from "axios";
import { Amendment } from "../types/Amendments";

interface ExportParams {
  fileId?: string;
  textId?: string;
  userId?: string;
  filters?: {
    id: number;
    metric: {
      label: string;
      value: string;
    }[];
    symbol: {
      label: string;
      value: string;
    }[];
    value: {
      label: string;
      value: string;
    }[];
  }[];
  deputyId?: string;
  signalId?: string;
  amendmentsTextFollowed?: boolean;
  amendmentsTextNotFollowed?: boolean;
  keywordsFilterBar?: string[];
}

const useAmendmentsExport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const exportAmendments = async (
    params: ExportParams
  ): Promise<Amendment[]> => {
    setLoading(true);
    setError(null);

    try {
      const requestParams: any = {
        export: true,
      };

      if (params.fileId && params.textId) {
        requestParams.uid = params.fileId;
        requestParams.textId = params.textId;
        requestParams.userId = params.userId;
      } else if (params.deputyId) {
        requestParams.deputyId = params.deputyId;
        requestParams.userId = params.userId;
      } else if (params.signalId) {
        requestParams.signalId = params.signalId;
        requestParams.userId = params.userId;
      } else if (params.amendmentsTextFollowed) {
        requestParams.amendmentsTextFollowed = params.amendmentsTextFollowed;
        requestParams.userId = params.userId;
      } else if (params.amendmentsTextNotFollowed) {
        requestParams.amendmentsTextNotFollowed =
          params.amendmentsTextNotFollowed;
        requestParams.userId = params.userId;
      }

      if (
        params.filters &&
        params.filters.some((filter) => filter || filter || filter)
      ) {
        requestParams.filters = JSON.stringify(params.filters);
      }

      if (params.keywordsFilterBar && params.keywordsFilterBar.length > 0) {
        requestParams.keywords = JSON.stringify(params.keywordsFilterBar);
      }

      const response = await axios.get(
        `https://oparl-textprovider-production.up.railway.app/amendments`,
        {
          //`http://localhost:1080/amendments`,
          params: requestParams,
        }
      );

      setError(null);
      return response.data.Amendments || [];
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        setError(`Error: ${err.response.statusText}`);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred");
      }
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { exportAmendments, loading, error };
};

export default useAmendmentsExport;
